import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class ViewCandidate extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            candidate: '',
            fields: {},
            errors: {},
            message1: '',
            notes: [],
            apiUrl: this.decryptconfigdata('apiUrl'),
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            userEmail: has_local_data ? localdata.user_email : '',
        };
        this.onChange = this.onChange.bind(this);
    }

    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }

    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }

    handleValidation() {
        let fields = this.state.fields;
        let errors = {};
        let formIsValid = true;
        console.log(this.state.fields);
        if (!fields["candidate_notes"]) {
            formIsValid = false;
            errors["candidate_notes"] = "This field is required.";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    onChange(event) {
        let fields = this.state.fields;
        this.setState({ [event.target.name]: event.target.value });
        fields[event.target.name] = event.target.value;
    }

    spaceKeyPress(event) {
        if (event.which == 32 && !event.target.value.length) {
            event.preventDefault();
        }
    }

    insertCandidateNote() {
        if (this.handleValidation()) {
            console.log("Data Has been submitted");
            //return true;
        } else {
            console.log("This Fields Are required.")
            return false;
        }
        document.getElementById("add_employee_note").innerHTML = "Sending....";
        const fd = new FormData;
        document.getElementById("add_employee_note").disabled = true;
        fd.append('candidate_inputs', JSON.stringify(this.state));
        fetch(this.state.apiUrl + '/HrmanagementRest/AddNoteToCandidate/id/' + this.props.match.params.candidateId + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                findresponse = this.decrypt(findresponse, 1);
                document.getElementById("add_employee_note").disabled = false;
                document.getElementById("add_employee_note").innerHTML = "Add Note";
                if (findresponse.code == 200) {
                    this.setState({ message1: findresponse.msg }, function () {
                        window.location.href = '/viewCandidate/' + this.state.candidate.id_hiring;
                        this.viewCandidate();
                    });

                } else {

                    this.setState({ message1: findresponse.msg })
                }

            })
    }

    download_resume(id) {
        fetch(this.state.apiUrl + '/HrmanagementRest/DownloadResume/id/' + id + '/userAuthKey/' + this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
            .then((Response) => Response.json())
            .then((findresponse) => {
                window.open(findresponse.url);

            })
    }

    viewCandidate() {
        fetch(this.state.apiUrl + '/HrmanagementRest/ViewCandidate/id/' + this.props.match.params.candidateId + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey)
            .then((Response) => Response.json())
            .then((responseJson) => {
                responseJson = this.decrypt(responseJson, 1);
                this.setState({
                    loading: 0,
                    candidate: responseJson.candidate,
                    notes: responseJson.notes,
                })
            })
    }

    componentDidMount() {
        document.title = "Intranet | Candidate Details";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.viewCandidate();

    }

    getViewdetails() {
        if (this.state.loading) {
            return (
                <div>
                    <div class="loader-new"></div>
                </div>
            )
        } else {
            return (
                <div class="form-section border-bottom ">
                    <div class="details">
                        <div class="candidate_details_title">Name :</div>
                        <div class="candidate_details_des">
                            {this.state.candidate.name ? this.state.candidate.name : '--'}
                        </div>
                    </div>
                    <div class="details">
                        <div class="candidate_details_title">Profile :</div>
                        <div class="candidate_details_des">
                            {this.state.candidate.profile ? this.state.candidate.profile : '--'}
                        </div>
                    </div>
                    <div class="details">
                        <div class="candidate_details_title">Years Of Experience :</div>
                        <div class="candidate_details_des">
                            {this.state.candidate.exp ? this.state.candidate.exp : '--'}
                        </div>
                    </div>
                    <div class="details">
                        <div class="candidate_details_title">Status :</div>
                        <div class="candidate_details_des">
                            {this.state.candidate.status ? this.state.candidate.status : '--'}
                        </div>
                    </div>
                    <div class="details">
                        <div class="candidate_details_title">Social Media Links :</div>
                        <div class="candidate_details_des">
                            {this.state.candidate.social_media_links ?
                                <div class=""><span class="">{
                                    this.state.candidate.social_media_links.split("muvi@1234").map(place =>
                                        <p > <a href={place} target="_blank"> {place}</a> </p>
                                    )

                                }</span></div>
                                : '--'}
                        </div>
                    </div>
                    <div class="details">
                        <div class="candidate_details_title">Resume :</div>
                        <div class="candidate_details_des">
                            {this.state.candidate.resume ? <span onClick={() => this.download_resume(this.state.candidate.id_hiring)}><a href="javascript:void(0)">{this.state.candidate.resume}</a></span> : '--'}
                        </div>
                    </div>
                    <div class="details">
                        <div class="candidate_details_title">Interviewer Name :</div>
                        <div class="candidate_details_des">
                            {this.state.candidate.interviewer ? this.state.candidate.interviewer : '--'}
                        </div>
                    </div>
                    <div class="details">
                        <div class="candidate_details_title">Rating :</div>
                        <div class="candidate_details_des">
                            {this.state.candidate.rating ? this.state.candidate.rating : '--'}
                        </div>
                    </div>

                </div>
            )
        }
    }

    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'} />
            )
        }
        return (
            <div>
                <Header brecum_name="Employee" brecum_page="Candidate Details" />
                <div class="right_col" role="main">
                    <section class="intranet_body">
                        <div class="title mob hidden-md"><HeaderMob page_name="Candidate Details" /></div>
                        <div class="title emps_mob">
                            <span class="job_title">Candidate Details</span>
                            <div class="mob-angle hidden-md pull-left"><i class="fa fa-angle-left" onclick="goBack()"></i></div>
                            {this.getViewdetails()}
                            <div class="add_note_history">
                                <div class="feedback">
                                    <h5 class="title"><span>Add Note</span></h5>

                                    <div class="row intra_form emp_mob">
                                        <div class="col-md-12 col-xs-12">
                                            <div class="form-group row">
                                                <div class="col-sm-12 col-xs-12">
                                                    <div class="searchMaster emp_dept">
                                                        <textarea id="candidate_notes" class="form-control" name='candidate_notes' placeholder="" rows="4" onKeyPress={this.spaceKeyPress} onChange={this.onChange} required></textarea>
                                                    </div>
                                                    <span class="error">{this.state.errors["candidate_notes"]}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="intra_form">
                                        <button type="submit" name="add_employee_note" id="add_employee_note" class="btn btn-sky mob-btn" onClick={() => this.insertCandidateNote()}>Add Note</button>
                                        <Link to={`/hiring/`} name={"max"}> <button className="btn btn-blue hidden-sm" >Back</button></Link>
                                    </div>
                                    <span style={{ color: "green" }}>{this.state.message1}</span>
                                </div>


                                <div class="feedback">
                                    <h5 class="title"><span>Notes</span></h5>
                                    {
                                        this.state.notes.map((data, key) =>
                                            <div class="sub_feedback">
                                                <div class="main">
                                                    <div class="pro_image">
                                                        {data.image ? <img src={data.image} /> : <span class="profile_first_name"> {data.user_first_name.charAt(0).toUpperCase()}</span>}

                                                    </div>
                                                    <h6>{data.user_id ? data.user_id : '--'}</h6>
                                                    <span>{data.date}</span>
                                                </div>
                                                <div class="sub">
                                                    <h6>Note {data.id}</h6>
                                                    <p><div dangerouslySetInnerHTML={{ __html: data.note }} /></p>
                                                </div>
                                                <div class="details_des"><span class="color-sky">
                                                </span>
                                                </div>


                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        )
    }


}
export default ViewCandidate;


// WEBPACK FOOTER //
// ./src/components/hiring/viewCandidate.js